import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import jwt_decode from "jwt-decode";
import { User } from "../models/auth.models";
import { environment } from "src/environments/environment";
import { map } from "rxjs/operators";
import { Router } from "@angular/router";

@Injectable({ providedIn: "root" })
export class AuthenticationService {
  user: User;

  constructor(private http: HttpClient, private router: Router) {}

  private checkActiveSession(dateF) {
    const now = Math.trunc(new Date().getTime() / 1000);

    if (now > dateF) {
      this.logout();
      this.router.navigate(["/account/login"]);
      //console.log("Salir");
    }
  }

  public currentUser(): any {
    if (!this.user) {
      if (localStorage.getItem("token")) {
        var tmpU: any = jwt_decode(localStorage.getItem("token"));
        this.checkActiveSession(tmpU.exp);
        this.user = tmpU.user;
        this.user.token = localStorage.getItem("token");
        //console.log(this.user);
      } else this.logout();
    }
    return this.user;
  }

  /**
   * Performs the auth
   * @param email userEmail of user
   * @param pass userPassword of user
   */
  login(email: string, pass: string) {
    return this.http
      .post<any>(environment.api.apiDomain + `users/authenticate`, {
        email,
        pass,
      })
      .pipe(
        map((response) => {
          // login successful if there's a jwt token in the response
          if (response.token) {
            let tempU: any = jwt_decode(response.token);
            this.user = tempU.user;
            this.user.token = response.token;
            // store user details and jwt in cookie
            localStorage.setItem("token", JSON.stringify(response.token));
          }
          return response;
        })
      );
  }

  /**
   * Logout the user
   */
  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem("token");
    this.user = null;
  }

  getUserId(): string {
    const currentUser = this.currentUser();
    return currentUser ? currentUser._id : null;
  }
}
